/* eslint-disable import/no-webpack-loader-syntax */
import { getAIPageContextInstance } from '@/utils/global/api';
import dts from '!!raw-loader!./wuji-workflow.d.ts';
export async function getTypeDefinitions() {
    console.log(dts);
    return dts;
}
export default class WujiWorkflow {
    useWorkflow = () => {
        const w = getAIPageContextInstance();
        return w.workflow;
    };
    useFlow = () => {
        const w = getAIPageContextInstance();
        return w.flow;
    };
    // 支持 import workflow from '@wujibase/wuji-workflow' 的形式
    get default() {
        return this;
    }
}
